import { render, staticRenderFns } from "./doctor-page.vue?vue&type=template&id=92aed7a8"
import script from "./doctor-page.vue?vue&type=script&lang=js"
export * from "./doctor-page.vue?vue&type=script&lang=js"
import style0 from "./doctor-page.vue?vue&type=style&index=0&id=92aed7a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports